import store from '@/store';
export const option = {
  menuSpan: 6,
  submitBtn:false,
  emptyBtn:false,
  column: [
    {
      label: '所属代理商',
      prop: 'businessDeptId',
      type: 'select',
      filterable: true,
      dicData: store.getters.companies,
      props: {
        label: 'title',
        value: 'id',
      },
      span: 6,
    },
    {
      label: '产品类型',
      prop: 'rentType',
      type: 'select',
      dicData: store.getters.porductTypes,
      span: 6,
    },
    {
      label: '选择时间',
      prop: 'dateDay',
      type: 'date',
      valueFormat:'yyyy-MM-dd',
      span: 6,
      pickerOptions:{
        disabledDate(time) {
            return time.getTime() > Date.now();
          },
      },
    },
  ],
};
// class       css 名            span       一行占据的格
// isProgress  是否为进度条        progress   进度条内的 内容
// isBigImg    是否占据两格
// name        右边的 名称
// num         右边的 数字
// icon        图片
// 租后逾期总览
export const  statisticsTodayData= [
  {
    class: 'progress progress-img',
    span:4,
    isBigImg: false,
    isProgress: false,
    icon:'1_1',
    name: '逾期客户数',
    num: 0,
    id:"OverdueCustomer"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:4,
    isProgress: false,
    icon:'1_2',
    name: '逾期代偿数',
    num: 0,
    id:"OverdueCompensate"
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:4,
    isProgress: true,
    progress: {
      name: 'D1率',
      num: 0,
      type: 'circle',
      color:'#F285BF'
    },
    name: 'D1数',
    num: 0,
    id:'D1'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:4,
    isProgress: true,
    progress: {
      name: 'D2率',
      num: 0,
      type: 'circle',
      color:'#8D65F4'
    },
    name: 'D2数',
    num: 0,
    id:'D2'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:4,
    isProgress: true,
    progress: {
      name: 'D3率',
      num: 0,
      color:"#5790F2",
      type: 'circle',
    },
    name: 'D3数',
    num: 0,
    id:'D3'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:4,
    isProgress: true,
    progress: {
      name: 'M1率',
      num: 0,
      type: 'circle',
      color:"#5767F2",
    },
    name: 'M1数',
    num: 0,
    id:'M1'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:4,
    isProgress: true,
    progress: {
      name: 'M2率',
      num: 0,
      type: 'circle',
      color:"#57D2F2",
    },
    name: 'M2数',
    num: 0,
    id:'M2'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:4,
    isProgress: true,
    progress: {
      name: 'M3率',
      num: 0,
      type: 'circle',
      color:"#F2C957",
    },
    name: 'M3数',
    num: 0,
    id:'M3'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:4,
    isProgress: true,
    progress: {
      name: 'M4率',
      num: 0,
      type: 'circle',
      color:"#B057F2",
    },
    name: 'M4数',
    num: 0,
    id:'M4'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:4,
    isProgress: true,
    progress: {
      name: 'M5率',
      num: 0,
      type: 'circle',
      color:"#F28657",
    },
    name: 'M5数',
    num: 0,
    id:'M5'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:4,
    isProgress: true,
    progress: {
      name: 'M6率',
      num: 0,
      type: 'circle',
      color:"#FFB901",
    },
    name: 'M6数',
    num: 0,
    id:'M6'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:4,
    isProgress: true,
    progress: {
      name: 'M7率',
      num: 1,
      type: 'circle',
      color:"#43D4AE",
    },
    name: 'M7数',
    num: 0,
    id:'M7'
  },
]

// 租后数据统计
export const  statisticsData= [
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'2_1',
    name: '应收客户数',
    num: 0,
    type:1,
    id:'receivableCustomers'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:12,
    isProgress: true,
    isProgressNum:true,
    progress: {
      name: '催收率',
      num: 0,
      type: 'circle',
      color:'#8D65F4',
      id:'collectionCustomerRate'
    },
    name: '催收客户数',
    num: 0,
    type:1,
    id:'collectionCustomers'
  },
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'2_2',
    name: '实收客户数',
    num: 0,
    type:1,
    id:'actualPaymentCustomers'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:12,
    isProgress: true,
    isProgressNum:true,
    progress: {
      name: '通知率',
      num: 0,
      type: 'circle',
      color:'#5790F2',
      id:'notificationCustomerRate'
    },
    name: '通知客户数',
    num: 0,
    type:1,
    id:'notificationCustomers'
  },
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'3_1',
    name: '回款率',
    num: 0,
    type:1,
    isPercent:true,
    id:'returnedMoneyRate'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:12,
    isProgress: true,
    isProgressNum:true,
    progress: {
      name: '逾期率',
      num: 0,
      type: 'circle',
      color:'#F285BF',
      id:'yesterdayOverdueCustomerRate'
    },
    name: '昨日逾期客户数',
    num: 0,
    type:1,
    id:'yesterdayOverdueCustomers'
  },
  {
    class: 'big_img',
    isBigImg: false,
    span:12,
    isProgress: true,
    progress: {
      name: '通知率',
      type: 'circle',
      color:'#5790F2'
    },
    name: '通知率',
    num: 0,
    isPercent:true,
    type:2,
    id:'notificationCustomerRate'
  },
  {
    class: 'big_img',
    isBigImg: false,
    span:12,
    isProgress: true,
    progress: {
      name: '催收率',
      type: 'circle',
      color:'#8D65F4'
    },
    name: '催收率',
    isPercent:true,
    num: 0,
    type:2,
    id:'collectionCustomerRate'
  },
  {
    class: 'big_img',
    isBigImg: false,
    span:12,
    isProgress: true,
    progress: {
      name: '逾期率',
      type: 'circle',
      color:'#F285BF'
    },
    name: '昨日逾期率',
    num: 0,
    isPercent:true,
    type:2,
    id:'yesterdayOverdueCustomerRate'
  },
  {
    class: 'big_img',
    isBigImg: false,
    span:12,
    isProgress: true,
    progress: {
      name: '回款率',
      type: 'circle',
      color:'#57D2F2'
    },
    name: '回款率',
    isPercent:true,
    num: 0,
    type:2,
    id:'returnedMoneyRate'
  },
]

// 代偿每月数据统计
export const compensatoryData =[
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'3_1',
    name: '预计代偿客户数',
    num: 0,
    type:1,
    id:'estCompCustCount'
  },
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'3_2',
    name: '待代偿客户数',
    num: 0,
    type:1,
    id:'pendCompCustCount'
  },
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'3_3',
    name: '未代偿客户数',
    num: 0,
    type:1,
    id:'nonCompCustCount'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:12,
    isProgress: true,
    isProgressNum:true,
    progress: {
      name: '未代偿率',
      num: 0,
      type: 'circle',
      color:'#8D65F4',
      id:"nonCompRate"
    },
    name: '未代偿金额',
    num: 0,
    type:1,
    id:'nonCompAmount'
  },
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'3_3',
    name: '待代偿金额',
    num: 0,
    type:1,
    id:'pendCompAmount'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:12,
    isProgress: true,
    progress: {
      name: '待代偿',
      type: 'circle',
      color:'#5790F2'
    },
    name: '待代偿率',
    isPercent:true,
    num: 0,
    type:1,
    id:'pendCompRate'
  },
  {
    class: 'big_img2',
    isBigImg: false,
    span:12,
    isProgress: true,
    progress: {
      name: '待代偿',
      type: 'circle',
      color:'#8D65F4'
    },
    name: '待代偿率',
    num: 0,
    isPercent:true,
    type:2,
    id:'pendCompRate'
  },
  {
    class: 'big_img2',
    isBigImg: false,
    span:12,
    isProgress: true,
    progress: {
      name: '未代偿',
      type: 'circle',
      color:'#5790F2'
    },
    name: '未代偿率',
    num: 0,
    isPercent:true,
    type:2,
    id:'nonCompRate'
  },
]

// 行动当月数据统计
export const actionData1 = [
  {
    class: 'big_img',
    span:24,
    isBigImg: false,
    isProgress: false,
    icon:'4_1',
    name: '待拖车数',
    num: 0,
    progress: {
      num: 50,
    },
    id:'pendingTrailerCount'
  },
  {
    class: 'big_img',
    span:24,
    isBigImg: false,
    isProgress: false,
    icon:'4_3',
    name: '未拖回数',
    num: 0,
    progress: {
      num: 50,
    },
    id:'unreturnedTrailerCount'
  },
]
export const actionData2 = [
  {
    class: 'progress progress-img',
    span:24,
    isBigImg: false,
    isProgress: false,
    icon:'4_2',
    name: '已拖回数',
    num: 0,
    id:'returnedTrailerCount'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:24,
    isProgress: true,
    progress: {
      name: '拖车',
      type: 'circle',
      color:"#5790F2",
    },
    name: '拖回率',
    num: 0,
    isPercent:true,
    id:'returnRate'
  },
  {
    class: 'progress progress-img',
    span:24,
    isBigImg: false,
    isProgress: false,
    icon:'4_4',
    name: '转法务',
    num: 0,
    id:'transferToLegalCount'
  },
]

// 谈判当月数据统计
export const negotiationData = [
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'5_1',
    name: '待谈判数',
    num: 0,
    type:1,
    id:'totalWaitNegotiationCustomer'
  },
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'5_2',
    name: '卖车待售数',
    num: 0,
    type:1,
    id:'totalWaitSaleCar'
  },
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'5_3',
    name: '实收滞纳金',
    num: 0,
    type:1,
    id:'totalHadRepaymentOverdueFine'
  },
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'5_4',
    name: '应收滞纳金',
    num: 0,
    type:1,
    id:'totalNeedRepaymentOverdueFine'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:12,
    isProgress: true,
    progress: {
      name: '滞纳金',
      type: 'circle',
      color:'#B057F2'
    },
    name: '收取率',
    num: 0,
    isPercent:true,
    id:'overdueFineChargeRate'
  },
  {
    class: 'progress progress-rate',
    isBigImg: false,
    span:12,
    isProgress: true,
    progress: {
      name: '滞纳金',
      type: 'circle',
      color:'#5790F2'
    },
    isPercent:true,
    name: '减免率',
    num: 0,
    id:'overdueFineReliefRate'
  },
]

// 法务每月数据统计
export const lawData = [
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'6_1',
    name: '待诉讼数',
    num: 0,
    type:1,
    id:'pendingLawsuit'
  },
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'6_2',
    name: '诉讼中数',
    num: 0,
    type:1,
    id:'inALawsuit'
  },
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'6_3',
    name: '已判决数',
    num: 0,
    type:1,
    id:'sentenced'
  },
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'6_4',
    name: '已调解数',
    num: 0,
    type:1,
    id:'mediated'
  },
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'6_5',
    name: '刑事案件数',
    num: 0,
    type:1,
    id:'transferToACriminal'
  },
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'6_6',
    name: '委托第三方数',
    num: 0,
    type:1,
    id:'entrustAThirdParty'
  },
]

// 维护当月数据统计
export const maintainData = [
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'7_1',
    name: '交强险过期未处理',
    num: 0,
    id:'carInsurance1EndDateCount'
  },
  {
    class: 'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'7_2',
    name: '商业险过期未处理',
    num: 0,
    id:'carInsurance2EndDateCount'
  },
  {
    class:'progress progress-img',
    span:12,
    isBigImg: false,
    isProgress: false,
    icon:'7_3',
    name: '年检到期未处理',
    num: 0,
    id:'carInspectionEndDateCount'
  },
]

